import { create } from "zustand";
import { EventData, DesignDetails, DesignSettingsV1, MetadataJson } from "../../types/event";

interface EventStore {
    eventId: string | null;
    setEventId: (id: string | null) => void;
    eventData: EventData | null;
    setEventData: (data: EventData | null) => void;
    metadataJson: MetadataJson | null;
    setMetadataJson: (metadata: MetadataJson | null) => void;
    designSettings: (DesignSettingsV1 & { [key: string]: any }) | null;
    setDesignSettings: (settings: (DesignSettingsV1 & { [key: string]: any }) | null) => void;
    designDetails: (DesignDetails & { [key: string]: any }) | null;
    setDesignDetails: (details: (DesignDetails & { [key: string]: any }) | null) => void;
    publishStatus: number | null;
    setPublishStatus: (status: number | null) => void;
    galleryMode: number | null;
    setGalleryMode: (mode: number | null) => void;
    isGalleryExpired: boolean;
    setIsGalleryExpired: (expired: boolean) => void;
    isDesignPreview: boolean;
    setIsDesignPreview: (isPreview: boolean) => void;
    

    isEmbed: boolean; 
    setIsEmbed: (isEmbed: boolean) => void;
    
    showCover: boolean; 
    setShowCover: (showCover: boolean) => void;

    bearerToken: string | null;
    setBearerToken: (token: string | null) => void;
    clearEventData: () => void;
}

export const useEventStore = create<EventStore>((set) => ({
    eventId: null,
    setEventId: (id) => set({ eventId: id }),
    eventData: null,
    setEventData: (data) => set({ eventData: data }),
    metadataJson: null,
    setMetadataJson: (metadata) => set({ metadataJson: metadata }),
    designSettings: null,
    setDesignSettings: (settings) => set({ designSettings: settings }),
    designDetails: null,
    setDesignDetails: (details) => set({ designDetails: details }),
    publishStatus: null,
    setPublishStatus: (status) => set({ publishStatus: status }),
    galleryMode: null,
    setGalleryMode: (mode) => set({ galleryMode: mode }),
    isGalleryExpired: false,
    setIsGalleryExpired: (expired) => set({ isGalleryExpired: expired }),
    isDesignPreview: false,
    setIsDesignPreview: (isPreview: boolean) => set({ isDesignPreview: isPreview }),


    isEmbed: false,
    setIsEmbed: (value) => set({ isEmbed: value }),
    showCover: true, // Default to true so standard galleries look normal
    setShowCover: (value) => set({ showCover: value }),
 

    bearerToken: null,
    setBearerToken: (token) => set({ bearerToken: token }),
    clearEventData: () =>
        set({
            eventData: null,
            metadataJson: null,
            designSettings: null,
            designDetails: null,
            publishStatus: null,
            galleryMode: null,
            isGalleryExpired: false,
            isDesignPreview: false,
            isEmbed: false, // Reset this too
            showCover: true,
            bearerToken: null,
        }),
}));